"use client";

import Box from "@mui/material/Box"; // GLOBAL CUSTOM COMPONENTS
import SectionCreator from "./default/section-creator";
import { CAROUSEL_ARROW_STYLE } from "src/lib/components/category-section/bazaar/styles";
import { Carousel } from "../salify-next-layout/default/components/carousel";
import SalifyFallback from "src/lib/components/salify-fallback/default";
import React, { useEffect, useState } from "react";
import { Product } from "src/lib/fetcher/client";
import { useMediaQuery, useTheme } from "@mui/material";
import clsx from "clsx";
import ProductItemVertical from "src/lib/components/product-item/vertical";

// =========================================================

export interface VariantProps {
  title: string;
  subTitle?: string;
  featuredOption?: string;
  isFrequentlyViewed?: boolean;
}
const ProductListSection: React.FC<VariantProps> = ({
  title,
  subTitle,
  featuredOption,
  isFrequentlyViewed,
}) => {
  const output = isFrequentlyViewed
    ? "output:productsByFrequentlyViewed.data"
    : "output:products.data";
  const products = SalifyFallback.useSelect<Product[]>(output);
  const [isAfterInit, setIsAfterInit] = useState(false);
  const { breakpoints } = useTheme();
  const isMobile = useMediaQuery("(max-width:767px)");
  const responsive = [
    {
      breakpoint: breakpoints.values.md,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: breakpoints.values.sm,
      settings: {
        slidesToShow: 1.25,
        centerMode: true,
      },
    },
  ];
  const cls = clsx({
    "on-init": !isAfterInit,
  });
  const defaultSlideToShow = 4;
  const [slideToShow, setSlideToShow] = useState(defaultSlideToShow);
  useEffect(() => {
    if (isMobile) {
      setSlideToShow(1);
    }
  }, [isMobile]);
  return (
    products && (
      <SectionCreator
        title={title}
        subTitle={subTitle}
        seeMoreLink="/collection"
        bgColor={isMobile ? "inherit" : "white"}
      >
        <Box
          className={cls}
          sx={
            products.length > slideToShow
              ? undefined
              : {
                  "& .slick-track": {
                    width: "100% !important",
                  },
                }
          }
        >
          <Carousel
            dotColor={undefined}
            slidesToShow={slideToShow}
            initialSlide={0}
            responsive={responsive}
            arrowStyles={CAROUSEL_ARROW_STYLE}
            onInit={() => {
              setIsAfterInit(true);
            }}
          >
            {products.map((item, index) => (
              <Box pb={2} key={index} sx={{ height: "inherit" }}>
                <ProductItemVertical {...item} highlightPrice featuredOption={featuredOption} />
              </Box>
            ))}
          </Carousel>
        </Box>
      </SectionCreator>
    )
  );
};

export default ProductListSection;
